import $ from 'jquery'

export default {

  enable () {
    $('.block-contact').each((index, block) => {

      
    })
  }
}



// WEBPACK FOOTER //
// ./src/js/blocks/block-contact.js